export enum ProfileSections {
    socialNetwork = "socialNetwork",
    nftProfile = "nftProfile",
    poapsProfile = "poapsProfile",
    experiencesProfile = "experiencesProfile",
}
